/**
 * KAN-1141 (RD-UI-190) — the ONE number scale. Every figure the app shows big (a hero count, a
 * dashboard headline, a secondary amount, a compact count) takes its size, weight, tracking and
 * line height from here, in Hanken Grotesk (`fontFamily.sans`) with tabular numerals. Never hand-
 * type a figure style; `figureType.guard.test.js` fails on one.
 *
 *   hero       32 / 700 / -0.02em / 1.1   tab heroes AND dashboard headlines (same style)
 *   secondary  24 / 700 / -0.01em / 1.15  month band cells, Next 7 days, AI usage
 *   compact    18 / 600 / 0 / 1.3         ring centre, legend amounts, row totals, seat meters
 *
 * CSS files (`homeDashboard.css`, …) read the same numbers through the `--cvx-fig-*` custom
 * properties in `figureType.css` (imported once from `src/index.js`); `figureType.guard.test.js`
 * pins the pair, like fieldTouchFont.css.
 */
import { foundation } from './tokens';

export const FIGURE_SCALE = {
  hero: { size: 32, weight: 700, tracking: '-0.02em', line: 1.1 },
  secondary: { size: 24, weight: 700, tracking: '-0.01em', line: 1.15 },
  compact: { size: 18, weight: 600, tracking: '0', line: 1.3 },
};

/** A short phone shrinks the hero figure one step (segmentHeroMetrics). */
export const HERO_FIGURE_SHORT_PX = 28;

const build = ({ size, weight, tracking, line }) => ({
  fontFamily: foundation.fontFamily.sans,
  fontSize: `${size}px`,
  fontWeight: weight,
  letterSpacing: tracking,
  lineHeight: line,
  fontVariantNumeric: 'tabular-nums',
});

export const heroFigureStyle = build(FIGURE_SCALE.hero);
export const secondaryFigureStyle = build(FIGURE_SCALE.secondary);
export const compactFigureStyle = build(FIGURE_SCALE.compact);

/** Dashboard headline = the hero figure (one number style app-wide). */
export const headlineFigureStyle = heroFigureStyle;
